module.exports = __webpack_public_path__ + "static/media/site.c2f55242.webmanifest";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yieldlock-favicon/site.webmanifest
// module id = 1443
// module chunks = 0